import type { TFunction } from "i18next";
import { z } from "zod";

export const RESOLVE_DISPUTE_DOCUMENT_FIELD = "resolveDisputeDocuments" as const;
export const RESOLVE_DISPUTE_DOCUMENT_CERTIFICATE_TYPE = "RESOLVE_DISPUTE_DOCUMENT";
export const RESOLVE_DISPUTE_DETAILS_MAX_LENGTH = 2000;
export const RESOLVE_DISPUTE_DOCUMENTS_MAX_FILES = 5;

const resolveDisputeDocumentSchema = z.object({
  originalFileName: z.string(),
  url: z.string(),
});

export const getResolveDisputeDrawerSchema = (t: TFunction) =>
  z.object({
    resolutionDetails: z
      .string()
      .trim()
      .min(
        1,
        t("form-validation.required", {
          label: t("vessel-call.operations.resolution-details"),
        }),
      )
      .max(
        RESOLVE_DISPUTE_DETAILS_MAX_LENGTH,
        t("form-validation.max-length", {
          label: t("vessel-call.operations.resolution-details"),
          max: RESOLVE_DISPUTE_DETAILS_MAX_LENGTH,
        }),
      ),
    [RESOLVE_DISPUTE_DOCUMENT_FIELD]: z
      .array(resolveDisputeDocumentSchema)
      .max(
        RESOLVE_DISPUTE_DOCUMENTS_MAX_FILES,
        t("form-validation.max-length", {
          label: t("vessel-call.operations.resolution-documents"),
          max: RESOLVE_DISPUTE_DOCUMENTS_MAX_FILES,
        }),
      )
      .optional(),
  });
